import React, {useState} from 'react';
import Grid from '@mui/material/Grid2';
import {useTranslation} from "react-i18next";
import axios from "axios";
import {defaultVariables} from "../../../../../config";
import GetConfirmationButton from "../../../../components/elements/GetConfirmationButton";
import {Card, Switch, Typography} from "@mui/material";
import {CheckBoxRounded, DeleteForeverOutlined} from "@mui/icons-material";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../../config/design/styles";
import {getMediaURL} from "../../../../../config/values";
import Avatar from "@mui/material/Avatar";
import MakeCategoryButton from "../MakeCategoryButton";
import Box from '@mui/material/Box';
import CategoryCardChild from "./CategoryCardChild";
import {Trash} from "lucide-react";

function CategoryCard({classes,item,reload,is_child}){
    const { t } = useTranslation();
    const loginToken = localStorage.getItem('ACT');
    const [loading, setLoading] = useState(false);

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`
        }
    }
    const handleDelete = (item_id) =>{
        setLoading(true);
        let data = new FormData();
        data.append('id', item_id);
        axios.post(`${defaultVariables.url}/categories/delete`,data,config)
            .then(response => {
                setLoading(false);
                reload();

            })
            .catch(error => {
                console.error("Error fetching item data:", error);
                setLoading(false);
            });
    }
    const handleActive = (item_id) =>{

        let data = new FormData();
        data.append('id', item_id);
        axios.post(`${defaultVariables.url}/categories/toggle-active`,data,config)
            .then(response => {
                reload();
            })
            .catch(error => {
                console.error("Error fetching item data:", error);

            });
    }
    return (
        <Card className="item-card">
            <Grid container spacing={2}>
                <Grid item size={12}>
                    <Box className={classes.categoryHold}>
                        <div className="details">
                            <Avatar src={getMediaURL(item.file,'small')}/>
                            <div className="name-holder">
                                <Typography>{item.name}</Typography>
                            </div>
                        </div>

                        <div className="actions actions-gap">
                            <MakeCategoryButton item_id={item.id} reload={reload}/>
                            <Switch
                                size="small"
                                checked={item.active}
                                onChange={() => handleActive(item.id)}
                                color="secondary"
                            />
                            <GetConfirmationButton
                                handleAction={() => handleDelete(item.id)}
                                question={t('doYouWanaDeleteItem')}
                                icon={<CheckBoxRounded/>}
                                tooltip={t('delete')}
                                loading={loading}
                                iconColor="primary"
                            >
                                <Trash className="lucide-icon-primary btn"/>
                            </GetConfirmationButton>


                        </div>
                    </Box>
                    {
                        !is_child &&
                        <MakeCategoryButton child parent_id={item.id} reload={reload}/>
                    }
                    {
                        !!item.children &&
                        <div className="children_holder">
                            <Grid container spacing={2}>
                                {
                                    item.children.map((child,index) =>(
                                        <Grid item size={{xs:12,md:4,lg:3}} key={index}>
                                            <CategoryCardChild
                                                is_child
                                                item={child}
                                                reload={reload}
                                            />
                                        </Grid>

                                    ))
                                }
                            </Grid>

                        </div>
                    }
                </Grid>
            </Grid>
        </Card>
    );
}
export default withStyles(Styles)(CategoryCard);
